import React, { useContext, useEffect, useState } from 'react';

import { useNavigate, useParams } from "react-router-dom";
import { AuthContext } from "../../../../config/AuthContext";
import { Button, FloatButton, Select, Switch, Table, TableProps, Tag, Card, Space, Typography, Tooltip, Avatar } from "antd";
import { ColumnsType } from "antd/es/table";
import AvaluacioColors from "../../../../styles/AvaluacioColors";
import { BsPencil, BsUnity } from "react-icons/bs";
import { GetGrups } from "../../../../dao/abp/GetGrups";
import { GetProjecteId } from "../../../../dao/abp/GetProjecteId";
import { BiArrowFromLeft, BiArrowFromRight, BiPlus, BiRefresh } from "react-icons/bi";
import ProjecteModal from "../../projectes/ProjecteModal";
import GrupModal from "../GrupModal";
import { GetAlumne } from "../../../../dao/abp/GetAlumnes";
import { GetAlumnesProjecte } from "../../../../dao/abp/GetAlumnesProjecte";
import { GetAlumnesTasquesByProject } from "../../../../dao/abp/GetAlumnesTasquesByProject";
import { GetSprintsByProject } from "../../../../dao/abp/GetSprintsByProject";
import { FaGitlab } from "react-icons/fa";
import { UserOutlined } from "@ant-design/icons";

const { Text } = Typography;

const ProjecteIdGrups = () => {
    const { isLoggedIn, userId, user, setBreadCrumb } = useContext(AuthContext);
    const { id_grup, id_projecte, id_usuari } = useParams();
    const [modal, setModal] = useState(false);
    const [selected, setSelected] = useState<any>();
    const [alumnes, setAlumnes] = useState<any>([]);
    const [modules, setModules] = useState<any>([]);
    const [total, setTotal] = useState<any>(0);
    const [selectedIds, setSelectedIds] = useState<any>([]);
    const [sprintsMeta, setSprintsMeta] = useState<any[]>([]);

    const navigate = useNavigate();

    const [grups, setGrups] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);

    async function getAlumnes() {
        if (id_projecte) {
            console.log("Fetching alumnes for project:", id_projecte);
            const alus = await GetAlumnesProjecte(id_projecte);
            console.log("Raw Alumnes Fetch Result:", alus);
            const mapped = alus.map((a: any) => ({
                value: a.id,
                label: `${a.nom} ${a.cognoms}`,
                id_aula: a.id_aula,
                aula_nom: a.aula_nom
            }));
            console.log("Mapped Alumnes for Select:", mapped);
            setAlumnes(mapped);
        }
    }

    useEffect(() => {
        if (isLoggedIn) {
            checkDades();
        }
    }, [id_projecte]);

    function checkDades() {
        checkGrups();
        getAlumnes();
    }

    async function checkGrups() {
        setLoading(true);
        setGrups(await GetGrups(parseInt(id_projecte ? id_projecte : "0")));

        // Load detailed sprint metadata (dates, status, titles)
        const sMeta = await GetSprintsByProject(id_projecte || "0");
        setSprintsMeta(sMeta || []);

        const data = await GetProjecteId(id_projecte + "", 0);

        if (user.tipus === "0") {
            setBreadCrumb([{ nom: 'Home', nav: '/home' },
            { nom: 'avaluacio', nav: '/abp' },
            { nom: `${data.nom}`, nav: `/abp/projectes/${data.id}` }], true);

        } else {
            setBreadCrumb([{ nom: 'Home', nav: '/home' },
            { nom: 'avaluacio', nav: '/abp' },
            { nom: 'projectes', nav: '/abp/projectes' },
            { nom: `${data.nom}`, nav: `/abp/projectes/${data.id}` }], true);
        }

        setLoading(false);
    }


    function onClose(valor: boolean) {
        setModal(false);
        if (valor)
            checkGrups();
        setLoading(false);
    }

    const colors = [
        AvaluacioColors.colors.color1,
        AvaluacioColors.colors.color2,
        AvaluacioColors.colors.color3,
        AvaluacioColors.colors.color4,
        AvaluacioColors.colors.color5,
        AvaluacioColors.colors.color6
    ];

    function avaluarGrup(ele: any) {
        navigate(`grups/${ele.id}/avaluacio`);
        checkGrups();
    }

    function editar(ele: any) {
        setLoading(true);
        setSelected(ele);

        console.log(ele.alumnes);

        const ids = ele.alumnes?.map((alumne: any) => alumne.id);

        console.log(ids);
        setSelectedIds(ids);
        setModal(true);
    }

    const columns: ColumnsType<any> = [
        {
            key: 'id',
            dataIndex: 'id',
            width: 30,
            render: (text) => <Text type="secondary">#{text}</Text>
        },
        {
            title: 'Codi',
            key: 'codi',
            dataIndex: 'codi',
            defaultSortOrder: 'ascend',
            sorter: (a, b) => a.nom?.localeCompare(b?.nom),
            width: 120,
            render: (text) => <Text strong style={{ fontSize: '1.1em' }}>{text}</Text>
        },
        {
            title: 'Alumnes',
            key: 'alumnes2',
            dataIndex: 'alumnes2',
            render: (e, ele) => (
                <Space wrap>
                    {e && e.length > 0 ? (
                        e.map((val: any, index: number) => (
                            <Tag
                                key={index}
                                color={colors[index % 6]}
                                style={{ borderRadius: 12, padding: '2px 10px', fontSize: '13px', fontWeight: 500 }}
                            >
                                {val.nom} {val.cognoms}
                            </Tag>
                        ))
                    ) : (
                        <Tag color="default">Sense alumnes assignats</Tag>
                    )}
                </Space>
            )
        },
        {
            title: 'Progrés per Sprints',
            key: 'pendent',
            dataIndex: 'pendent',
            width: undefined,
            render: (e, ele) => {
                const isAdmin = user.tipus === "1" || user.tipus === "0";
                const isMyGroup = ele.alumnes2 && ele.alumnes2.some((alumne: any) => alumne.id == userId);

                if (!isAdmin && !isMyGroup) {
                    return <Text type="secondary" italic>Información oculta</Text>;
                }

                // Sort sprints by number
                const sortedSprints = ele.sprints ? [...ele.sprints].sort((a: any, b: any) => a.sprint - b.sprint) : [];

                return (
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
                        gap: '8px',
                        width: '100%'
                    }}>
                        {sortedSprints.map((sprint: any, index: number) => {
                            // Find metadata for this sprint (matching by number)
                            const meta = sprintsMeta.find(m => m.numero === sprint.sprint);

                            // Determine status based on dates
                            const now = new Date();
                            // Create date without time to avoid timezone issues, or use full date
                            const start = meta?.data_inici ? new Date(meta.data_inici) : null;
                            const end = meta?.data_final ? new Date(meta.data_final) : null;

                            let statusText = 'DESCONEGUT';
                            let statusColor = 'default';

                            if (start && end) {
                                if (now < start) {
                                    statusText = 'NO INICIAT';
                                    statusColor = 'default'; // Grey
                                } else if (now >= start && now <= end) {
                                    statusText = 'EN CURS';
                                    statusColor = 'green'; // Green
                                } else {
                                    statusText = 'TANCAT';
                                    statusColor = 'red'; // Red
                                }
                            } else {
                                // Fallback to DB status
                                if (meta?.estado === 'abierto') {
                                    statusText = 'OBERT';
                                    statusColor = 'green';
                                } else if (meta?.estado === 'cerrado') {
                                    statusText = 'TANCAT';
                                    statusColor = 'red';
                                } else {
                                    statusText = 'NO INICIAT';
                                    statusColor = 'default';
                                }
                            }

                            return (
                                <div key={sprint.sprint} style={{
                                    border: '1px solid #f0f0f0',
                                    padding: '8px',
                                    borderRadius: '6px',
                                    backgroundColor: '#fafafa',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    justifyContent: 'center'
                                }}>
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
                                        <Text strong style={{ fontSize: '13px' }}>S{sprint.sprint}: {meta?.titol || ''}</Text>
                                        <Tag color={statusColor} style={{ marginRight: 0, fontSize: '10px', lineHeight: '16px' }}>
                                            {statusText}
                                        </Tag>
                                    </div>

                                    {/* Dates - only show if available */}
                                    {start && end && (
                                        <div style={{ fontSize: '10px', color: '#8c8c8c', marginBottom: 4 }}>
                                            {start.toLocaleDateString()} - {end.toLocaleDateString()}
                                        </div>
                                    )}

                                    <Tooltip title="Color: Avaluant. Groc: Marcat per l'alumne pendent de corregir">
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 'auto' }}>
                                            <div style={{ flex: 1, marginRight: '8px', height: 6, background: '#e6e6e6', borderRadius: 3, overflow: 'hidden', display: 'flex' }}>
                                                <div
                                                    style={{
                                                        width: `${sprint.percentatge_completat}%`,
                                                        background: colors[index % 6],
                                                        height: '100%',
                                                        transition: 'width 0.3s'
                                                    }}
                                                />
                                                <div
                                                    style={{
                                                        width: `${sprint.percentatge_pendent_alumne || 0}%`,
                                                        background: '#faad14',
                                                        height: '100%',
                                                        transition: 'width 0.3s'
                                                    }}
                                                />
                                            </div>
                                            <Text type="secondary" style={{ fontSize: '11px', minWidth: 28, textAlign: 'right' }}>
                                                {Math.round((sprint.percentatge_completat || 0) + (sprint.percentatge_pendent_alumne || 0))}%
                                            </Text>
                                        </div>
                                    </Tooltip>
                                </div>
                            );
                        })}
                    </div>
                );
            }
        },
        {
            title: 'Tutor',
            key: 'tutor',
            dataIndex: 'tutor',
            width: 200,
            render: (e, ele) => (
                e ? (
                    <Space>
                        <Avatar size="small" icon={<UserOutlined />} style={{ backgroundColor: colors[e.length % 6] }} />
                        <Text>{e}</Text>
                    </Space>
                ) : <Text type="secondary" italic>No assignat</Text>
            )
        },
        {
            title: 'Accions',
            key: 'actions',
            dataIndex: 'actions',
            width: 150,
            render: (e, ele) => (
                <Space>
                    {(user.tipus === "1" || user.tipus === "0") && (
                        <Tooltip title="Editar Grup">
                            <Button
                                type="text"
                                icon={<BsPencil style={{ color: AvaluacioColors.colors.color6 }} />}
                                onClick={() => editar(ele)}
                            />
                        </Tooltip>
                    )}

                    {ele.alumnes2 && ele.alumnes2.length > 0 && (user.tipus === "1" || user.tipus === "0") && (
                        <Tooltip title="Avaluar / Accedir">
                            <Button
                                type="text"
                                icon={<BiArrowFromLeft style={{ color: AvaluacioColors.colors.color5, fontSize: '18px' }} />}
                                onClick={() => avaluarGrup(ele)}
                            />
                        </Tooltip>
                    )}

                    {ele.gitlab !== null && ele.gitlab !== '' && (user.tipus === "1" || user.tipus === "0") && (
                        <Tooltip title="Obrir GitLab">
                            <Button
                                type="text"
                                icon={<FaGitlab style={{ color: AvaluacioColors.colors.color4 }} />}
                                onClick={() => window.open(ele.gitlab, "_blank")}
                            />
                        </Tooltip>
                    )}
                </Space>
            ),
        },
    ];

    const options = [
        {
            value: 'Pendent',
            label: !(user.tipus === "1" || user.tipus === "0") ? "Pendent" : "Pendent (0)",
        },
        {
            value: 'No Presentat',
            label: !(user.tipus === "1" || user.tipus === "0") ? "No Presentat" : "No Presentat (0)",
        },
        {
            value: 'Malament',
            label: !(user.tipus === "1" || user.tipus === "0") ? "Malament" : "Malament (2)",
        },
        {
            value: 'Suficient',
            label: !(user.tipus === "1" || user.tipus === "0") ? "Suficient" : "Suficient (5)",
        },
        {
            value: 'Bé (*)',
            label: !(user.tipus === "1" || user.tipus === "0") ? "Bé (*)" : "Bé (*) (6,5)",
        },
        {
            value: 'Bé',
            label: !(user.tipus === "1" || user.tipus === "0") ? "Bé" : "Bé (7.5)",
        },
        {
            value: 'Molt bé (*)',
            label: !(user.tipus === "1" || user.tipus === "0") ? "Molt bé (*)" : "Molt bé (*) (9)",
        },
        {
            value: 'Molt bé',
            label: !(user.tipus === "1" || user.tipus === "0") ? "Molt bé" : "Molt bé (10)",
        },
    ];

    const tableProps: TableProps<any> = {
        loading
    };

    function nou() {
        setModal(true)
        setLoading(true);
        setSelected({});
    }

    return (
        <div style={{ padding: '24px', maxWidth: 1600, margin: '0 auto' }}>
            <br />
            {/* Header Section */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 24,
                background: '#fff',
                padding: '16px 24px',
                borderRadius: 12,
                boxShadow: '0 2px 8px rgba(0,0,0,0.05)'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                    <div style={{
                        backgroundColor: AvaluacioColors.colors.color1,
                        padding: 10,
                        borderRadius: 10,
                        color: 'white',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        <BsUnity size={24} />
                    </div>
                    <div>
                        <h2 style={{ margin: 0, fontSize: 24, fontWeight: 600, color: '#1f1f1f' }}>Grups del Projecte</h2>
                        <span style={{ color: '#8c8c8c' }}>Gestió i avaluació dels grups</span>
                    </div>
                </div>

                <div style={{ display: 'flex', gap: 12 }}>
                    {(user.tipus === "1" || user.tipus === "0") && !loading && (
                        <>
                            <Button
                                icon={<BiRefresh size={18} />}
                                onClick={() => checkDades()}
                                size="large"
                            >
                                Actualitzar
                            </Button>
                            <Button
                                type="primary"
                                icon={<BiPlus size={18} />}
                                onClick={() => nou()}
                                size="large"
                                style={{ backgroundColor: AvaluacioColors.colors.color6 }}
                            >
                                Nou Grup
                            </Button>
                        </>
                    )}
                </div>
            </div>

            {/* Main Content */}
            <Card
                bordered={false}
                style={{ borderRadius: 12, boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}
                bodyStyle={{ padding: 0 }}
            >
                <Table
                    size="middle"
                    {...tableProps}
                    columns={columns}
                    dataSource={grups}
                    pagination={false}
                    rowKey="id"
                    rowClassName="editable-row"
                />
            </Card>

            {modal && <GrupModal element={selected} visible={modal} onClose={onClose}
                id_projecte={id_projecte + ""} alumnes={alumnes}
                selectedIds={selectedIds} />}
        </div>
    );
};

export default ProjecteIdGrups;
